import { Follow as Follow_phosphor } from './Follow.phosphor';
import { Follow as Follow_zoomg } from './Follow.zoomg';
import { Follow as Follow_zoomit } from './Follow.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'zoomg':
      return Follow_zoomg;

    case 'phosphor':
      return Follow_phosphor;

    default:
      return Follow_zoomit;
  }
};

export const Follow = IconRenderer();
